import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from '@src/core/services';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent extends BaseResizableComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly userService = inject(UserService);

  userId?: string;
  organisationId?: string;

  override ngOnInit(): void {
    super.ngOnInit();

    if (!this.organisationId) {
      this.route.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(async params => {
        this.userId = params.get('id') ?? undefined;
        if (!this.userId) {
          this.userService.getAuthorizedUser().then(res => {
            this.userId = res?.id;
            this.organisationId = res?.organisationId;
            this.cdr.markForCheck();
          });
        } else {
          const users = await lastValueFrom(this.userService.getUsersData([this.userId]));
          if (users.length) {
            this.organisationId = users[0].organisationId;
          }
        }
      });
    }
  }
}
